export const ORDER_STATUS = ['Chưa Duyệt', 'Duyệt']
export const INVOICE_STATUS = ['Chưa xuất HĐ', 'Đã xuất HĐ']
export const SENTO = 'Super Admin'
export const LIST_PERMISSIONS = {
  DASHBOARD: 'dashboard_management',
  PRODUCTS: 'product_management',
  IMPORT_REQUEST: 'import_request_management',
  WAREHOUSE_REPORT: 'warehouse_report_management',
  WAREHOUSE_LOGS: 'warehouse_logs_management',
  PAYMENT_REQUEST: 'payment_request_management',
  ACCOUNTS: 'account_management',
}

export const APPROVED_STT = 'Duyệt'
export const PAYMENT_VOUCHER = 'Phiếu chi'
export const RECIEPT_VOUCHER ='Phiếu thu'
export const ABILITIES_TYPES = [
  {id: 'payment_voucher', label: PAYMENT_VOUCHER},
  {id: 'receipt_voucher', label: RECIEPT_VOUCHER}
]
export const BANKING_METHOD = 'Chuyển khoản'
export const CASH_METHOD ='Tiền mặt'
export const ABILITIES_PAYMENT_METHOD = [
  {id: 'banking', label: BANKING_METHOD},
  {id: 'cash', label: CASH_METHOD}
]

export const PAID = 'Đã thanh toán'
export const UNPAID ='Chưa thanh toán'
export const PAYMENT_STATUS = [
  {id: '0', label: UNPAID},
  {id: '1', label: PAID}
]

export const IMAGES_FORMATS = ["image/jpg", "image/jpeg", "image/png"];
export const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB
export const DEFAULT_PER_PAGE = 50;
export const IMPORT_REQUEST_EDITABLE_STATUS = ['new', 'preparing']
export const PD_EDITABLE_STATUS = ['new', 'rejected', 'inactive'];